import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { SignUp } from '@clerk/clerk-react';
import floobizMark from '../assets/floobiz-mark.jpg';
import './AuthShell.css';

const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'Floobiz';

export default function SignUpPage() {
  const [params] = useSearchParams();
  const redirectUrl = params.get('redirect_url') || '/buy';

  return (
    <div className="auth-shell">
      <div className="auth-shell-bg" aria-hidden />
      <Link to="/" className="auth-shell-brand">
        <img src={floobizMark} alt={SITE_NAME} />
        <span>{SITE_NAME}</span>
      </Link>
      <div className="auth-shell-card">
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          fallbackRedirectUrl={redirectUrl}
          forceRedirectUrl={redirectUrl}
        />
      </div>
      <Link to="/" className="auth-shell-back">← Back to home</Link>
    </div>
  );
}
